import React from 'react'
import MymMaster from '../mindYourMusic/MymMaster'

const MindYourMusic = () => {
    return (
        <MymMaster />
    )
}

export default MindYourMusic